import type { FeatureStyleNode } from '../feature-style.model';

// =============================================================================
// PARAMS - Feature configuration from widget config
// =============================================================================

/** Tangent feature parameters */
export interface TangentParams {
  /** Reference to parent function element */
  of: string;
  /** X-coordinate where tangent touches the curve */
  x: number;
}

// =============================================================================
// DEFAULTS
// =============================================================================

export const TANGENT_DEFAULT_PARAMS: Omit<TangentParams, 'of'> = {
  x: 0,
};

/**
 * Default theme for tangent feature.
 * Amber colored line and touch point.
 *
 * Subparts:
 * - `touchPoint`: The point where the tangent touches the curve (draggable glider)
 * - `tangentLine`: The tangent line itself
 */
export const TANGENT_DEFAULTS: FeatureStyleNode = {
  line: { color: 'amber', strokeWidth: 2 },
  point: { color: 'amber' },
};
